/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Routes from 'ContentUtils/Routes';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink';
import * as UserActions from 'ContentData/actions/Users';
import * as userSelectors from 'ContentData/selectors/users';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.email.${key}`;
const mapStateToProps = state => ({
  options: userSelectors.getOptions(state),
  users: userSelectors.getUsers(state),
  isLoading: userSelectors.getIsLoading(state)
});
const mapDispatchToProps = {
  fetchUsers: UserActions.fetchUsers
};
const connector = connect(mapStateToProps, mapDispatchToProps);
class EmailField extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onOpenChange = this.onOpenChange.bind(this);
    this.checkForInvalidUsers = this.checkForInvalidUsers.bind(this);
    this.state = {
      input: ''
    };
  }
  componentDidMount() {
    const {
      options
    } = this.props;
    if (!options.length) {
      // on initial load get user data to check canNotify = false with
      this.props.fetchUsers();
    } else {
      // to render or remove error message when re-mounted during session
      this.checkForInvalidUsers();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      value = [],
      options
    } = this.props;
    const {
      value: prevValue,
      options: prevOptions
    } = prevProps;
    const valueChanged = value && value.length && prevValue && prevValue.length && prevValue.length !== value.length;
    const optionsChanged = !prevOptions.length && options.length;
    if (valueChanged || optionsChanged) {
      this.checkForInvalidUsers();
    }
  }
  checkForInvalidUsers() {
    const {
      value = [],
      setError,
      users
    } = this.props;
    const invalidValue = value && Array.isArray(value) && value.find(val => users[val] && !users[val].canNotify);
    if (setError) {
      const errorNode = /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: i18nKey('canNotNotify_jsx'),
        options: {
          href: Routes.settings('users')
        },
        elements: {
          Link: UILink
        }
      });
      setError(invalidValue ? errorNode : null);
    }
  }
  onChange(e) {
    const {
      onFieldChange
    } = this.props;
    onFieldChange(e.target.value);
  }
  onOpenChange({
    target: {
      value: isOpen
    }
  }) {
    /**
     * This is a gross workaround for now. We can;t use both loadOptions and
     * multi = true in UISElect, so we have to mimic it for now until FaaST can
     * fix that issue.
     */
    if (isOpen) this.props.fetchUsers();
  }
  renderOption({
    option,
    children
  }) {
    if (!option.canNotify) return null;
    return /*#__PURE__*/_jsx(Fragment, {
      children: children
    });
  }
  render() {
    const {
      allow_custom_email_addresses = true,
      error = false,
      value = [],
      readOnly = false,
      required,
      options,
      isLoading,
      placeholder,
      useOnDark
    } = this.props;

    /* Some projects pass in immutables as values */
    const __value = value && value.asMutable ? value.asMutable() : value;
    return /*#__PURE__*/_jsx(UISelect, {
      allowCreate: allow_custom_email_addresses,
      anchorType: "button",
      buttonUse: useOnDark ? 'form-on-dark' : 'form',
      clearable: !required,
      error: error,
      isLoading: isLoading,
      multi: true,
      onChange: this.onChange,
      onOpenChange: this.onOpenChange,
      optionComponent: this.renderOption,
      options: options,
      placeholder: placeholder || I18n.text(i18nKey('placeholder')),
      readOnly: readOnly,
      value: __value || []
    });
  }
}
export default connector(EmailField);